// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"9a847912","781":"a1e9b2a0","912":"aab3526e","954":"b1f4ad3b","957":"8419938c"}[chunkId] + ".chunk.css";
};